import styled from 'styled-components';

import { getThemeProps } from 'ravenjs/utils/theme';

import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

const AccountSwitcherHeaderStyled = styled.header`
    width: 100%;
    background-color: ${MIGRATED_COLORS.white};
    border-bottom: 1px solid ${MIGRATED_COLORS.grey21};
    z-index: 10;
    ${getThemeProps('AccountSwitcherHeader.styles')};
`;

export const AccountSwitcherHeaderInner = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0; /* Remove gap for clean divider */

    /* Desktop: min-width 1200px */
    min-height: ${({ theme }) => {
        const height = getThemeProps('AccountSwitcherHeader.height', 46, { theme });
        return `${height}px`;
    }};

    /* Mobile: max-width 675px */
    @media (max-width: 675px) {
        min-height: 58px;
        flex-direction: column;
        align-items: stretch;
    }
`;

export const SectionSlot = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 0;

    /* Desktop/Tablet: Conditional 50% width when both sections present */
    flex: ${({ half }) => (half ? '0 0 50%' : '1 1 100%')};
    padding: 8px 82px;

    /* Conditional border-right for left section when impersonation is active */
    border-right: ${({ withDivider }) =>
        withDivider
            ? `1px solid var(--Secondary-Colors-Secondary-Border, ${MIGRATED_COLORS.tan})`
            : '0'};

    /* Tablet Landscape: 992px to 1199px */
    @media (min-width: 992px) and (max-width: 1199px) {
        padding: 8px 48px;
    }

    /* Tablet Portrait: max-width 991px */
    @media (max-width: 991px) {
        padding: 8px 48px;
    }

    /* Mobile: max-width 675px */
    @media (max-width: 675px) {
        flex: 1 1 100%;
        width: 100%;
        padding: 8px 15px;
        border-right: 0;

        /* Add bottom divider for first section when stacked */
        ${({ stackedDivider }) =>
            stackedDivider &&
            `border-bottom: 1px solid var(--Secondary-Colors-Secondary-Border, ${MIGRATED_COLORS.tan});`}
    }
`;

export default AccountSwitcherHeaderStyled;
